var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-card",
    {
      staticClass: "card-last_object",
      attrs: {
        error: _vm.error,
        loading: _vm.loading,
        placeholder: _vm.placeholder,
        isCustomizable: _vm.settings.isCustomizable
      },
      on: {
        "refresh-card": function($event) {
          return _vm.fetchCard("last_object", {}, true)
        },
        "edit-card": _vm.toggleSettingsForm,
        "hide-card": function($event) {
          return _vm.$emit("hide-card", "last_object")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "title" },
        [
          _vm._v("\n        " + _vm._s(_vm.name) + "\n        "),
          _c(
            "portal",
            { attrs: { to: "dashboardSettingsForm" } },
            [
              _vm.showSettingsForm
                ? _c("card-setting-overlay", {
                    attrs: {
                      formName: _vm.settingsFormName,
                      cardCustomSettings: _vm.customSettings,
                      cardSettings: _vm.settings,
                      cardName: _vm.type
                    },
                    on: {
                      fetched: _vm.fetchCard,
                      "close-form": _vm.toggleSettingsForm,
                      "custom-settings-saved": function($event) {
                        return _vm.fetchCard(_vm.type, {}, true)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        (_vm.cardData && _vm.cardData.length > 0) ||
        (_vm.cardData && _vm.cardData.error)
          ? _c("div", { staticClass: "ov-auto" }, [
              !_vm.cardData.error
                ? _c(
                    "div",
                    _vm._l(_vm.data, function(object) {
                      return _c("ul", { key: object.id }, [
                        _c(
                          "a",
                          { staticClass: "url", attrs: { href: object.url } },
                          [
                            _c(
                              "li",
                              { staticClass: "flex-row p-2" },
                              [
                                _c("CompassIcon", {
                                  staticClass: "mt-2",
                                  attrs: {
                                    icon: _vm.getIconByType(object.type)
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex-column ml-4 wp-10 ov-reset"
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "mb-1 fs-2 between" },
                                      [
                                        _c("span", { staticClass: "gray-60" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.humanNameType(object.type)
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "grey time" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("dateFormatter")(
                                                  object.timestamp,
                                                  "SLASHED_DATE_TIME"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "semibold fs-3" }, [
                                      _vm._v(_vm._s(object.name))
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                : _c("div", [
                    _c("div", { staticClass: "alert alert-danger" }, [
                      _vm._v(_vm._s(_vm.cardData.error))
                    ])
                  ])
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }